import theme from '~/design'

export const PatchNotesEnum = {
  newFeatures: {
    label: 'Novas funcionalidades',
    backgroundColor: theme.colors.primary,
  },
  improvements: {
    label: 'Melhorias',
    backgroundColor: theme.colors.primary,
  },
  bugFixes: {
    label: 'Correções',
    backgroundColor: theme.colors.primary,
  },
  removedFeatures: {
    label: 'Remoções',
    backgroundColor: theme.colors.primary,
  },
} as const
